module.exports = __webpack_public_path__ + "static/media/1-4.33a43a6b.png";